import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const AddNewFileDataLibrary = ({ Show, Hide, Title, projectData, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [format, setFormat] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const {studyId} = useParams()

  const handleFormatChange = (format) => {
    setFormat(format);
    setUploadFile(null);
  };

  const cleanInputBox = () => {
    Hide();
    setFormat("");
    setUploadFile("");
    setName("");
    setLabel("");
    setTitle("");
    setDescription("");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const csvType = file.type === "text/csv";
    const excelType =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (
      (format === "csv" && csvType) ||
      (format === "excel" && excelType)
    )
      setUploadFile(file);
    else {
      setUploadFile(null);
      alert(`Please select a ${format.toUpperCase()} file.`);
    }
  };

  const uploadFileinProjectDataLibrary = async () => {
    if (uploadFile) {
      setButtonLoader(true)
      const formData = new FormData();
      formData.append("studyId", studyId);
      formData.append("projectId", projectData?.projectId);
      formData.append("parentId", projectData?.uniqueId);
      formData.append("file", uploadFile);
      formData.append("label", label);
      formData.append("name", name);
      formData.append("fileName", title);
      formData.append("description", description);
      formData.append("type", "file");
      formData.append("category", projectData?.type);
      let result = await editorProjectServices.uploadFileinProjectDataLibrary(
        formData
      );
      setButtonLoader(false)
      if (result?.statusCode === 200) {
        cleanInputBox();
        getEditorProjectData();
      }
    }
  };

  const [error, setError] = useState("");

  const validatetitle = (input) => {
    const titleRegex = /^[a-zA-Z0-9_]+$/;

    if (!titleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Format{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleFormatChange(e.target.value)}
              value={format}
              required
            >
              <option value="">Select Format</option>
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Upload {format.toUpperCase()} File {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="file"
              disabled={!format}
              onChange={handleFileChange}
              accept={format === "csv" ? ".csv" : ".xls, .xlsx"}
              required
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">Name</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setName(e.target.value)}
              value={name}
            >
              <option value={null}>Select Name</option>
              <option value={0}>Row 1</option>
              <option value={1}>Row 2</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">Label</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setLabel(e.target.value)}
              value={label}
            >
              <option value={null}>Select Label</option>
              <option value={0}>Row 1</option>
              <option value={1}>Row 2</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Title {" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter File Title"
              onChange={(e) => {
                setTitle(e.target.value);
                validatetitle(e.target.value);
              }}
              value={title}
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small
                letters, underScore and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Description{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Enter File Description"
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              required
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={uploadFileinProjectDataLibrary}
            disabled={buttonLoader || !format || !uploadFile || !title || !description}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Uploading...
              </div>
            ) : (
              "Upload"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewFileDataLibrary;
